<div class="relative h-full w-full">
  <div class="dark:text-white relative flex flex-col items-center h-full dark:bg-background mt-0">
    @if (hasGranularity && (hasScenarioFilter | async)) {
      <app-granularity-dropdown [selectedPreset]="selectedPreset" (onChange)="onChange($event)"
        [isLoaded]="loaded"></app-granularity-dropdown>
    }
    <app-looker-embed-sdk (onLoaded)="loaded = true"
      [filters]="filters$ | async"
      [resetFilters]="isProductChart ? PRODUCT_RESET_FILTERS: SCENARIO_RESET_FILTERS"
      [theme]="theme$ | async"
      [hiddenFilters]="hiddenFilters$ | async"
      (onDrillMenuClick)="handleDrillMenuClick($event)"
      [dashboard]="dashboard"
      (hasScenarioFilter)="hasScenarioFilter.emit($event)"></app-looker-embed-sdk>
  </div>
</div>
